import React, { useEffect, useState } from "react";
import Text from "@components/Text";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { useDispatch } from "react-redux";
import { themeDefault } from "src/theme-revamp";
import Link from "@components/Link";
import Button from "./../../Components/Button";
import Bullet from "@components/_Revamp/Bullet";
import { useHistory } from "react-router-dom";
import Modal from "@components/_Revamp/Modal";
import BackModal from "../../Components/Modals/BackModal";
import { updateEligible } from "@redux/slices/SHIELD_STARTER/step3Slice";
import Accordion from "@components/_Revamp/Accordion";
import { useAvivaSelector } from "@redux/hook";
import { ROUTE_PATH } from "@static/route-paths";
import { isEmpty } from "lodash";
import MainContainer from "@pages/ShieldStarter/Components/Container";
import { trackOnLoad } from "@pages/ShieldStarter/Helpers/dataAnalyticsHelpers";

const DeclarationBulletsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  row-gap: 0px;
  @media screen and (max-width: 1280px) {
    padding: 0 0;
  }
  @media screen and (max-width: 768px) {
    padding: 0 0;
  }
`;

const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  max-width: 100%;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-size: 18px;
    padding: 0 24px;
  }
`;

const FormContainer = styled.div<FormHeaderContainerProps>`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
  opacity: 1;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  flex-direction: column;
  margin: ${(props) => (props.margin ? props.margin : "0 auto")};
  display: flex;
  // flex-wrap: wrap;
  justify-content: center;
  background-color: #fff;
  padding: 24px 64px;
  border-radius: 24px;

  @media screen and (max-width: 768px) {
    padding: 24px 16px;
  }
`;

const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 40px;
`;

const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
`;

const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 56px;
  column-gap: 24px;
  @media screen and (max-width: 768px) {
    column-gap: 0;
    row-gap: 10px;
    margin-top: 40px;
    flex-direction: column;
    align-items: center;
  }
`;

const AccordionContainer = styled.div`
  margin-top: 100px;
  padding-bottom: 50px;
  @media screen and (max-width: 767px) {
    margin-top: 40px;
  }
`;

const FormContentContainer = styled.div<FormHeaderContainerProps>`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
  margin: ${(props) => (props.margin ? props.margin : "0 20px;")};
  width: 100%;
  display: block;
  padding-bottom: 30px;
  @media screen and (max-width: 768px) {
  }
`;

const DeclarationParagraph = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22.4px;
  color: #434343;
`;

const container_default_css = css`
  margin-bottom: 0px;
  @media screen and (max-width: 588px) {
    margin: auto 24px;
    margin-top: 64px;
  }
`;

const title_default_css = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 16px;
  }
`;

const AccordionParagraph = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 25.2px;
  color: #434343;
`;

const bulletStyle = css`
  @media screen and (max-width: 588px) {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    & span {
      left: 10px;
    }
  }
`;

export interface MessageNoteProps {
  color?: string;
}

export interface ModalContainerProps {
  display?: boolean;
}

export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}

export interface FormHeaderContainerProps {
  margin?: string;
  maxWidth?: string;
}

function Eligibility() {
  const history = useHistory();
  const dispatch = useDispatch();
  const basicDetails = useAvivaSelector(
    (state) => state.shieldStarterStep1.whomToBuy
  );
  const coverage = useAvivaSelector(
    (state) => state.shieldStarterStep2.policyName
  );
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [backModalVisible, setBackModalVisible] = useState<boolean>(false);
  const myInfoForm: any = useAvivaSelector((state) => state.shieldStarterStep3);
  const transactionId = useAvivaSelector(
    (state) => state.shieldStarterStep3.transactionId
  );

  const onNoProcess = () => {
    setBackModalVisible(true);
  };

  const onYesProcess = () => {
    dispatch(updateEligible(true));
    if (isEmpty(myInfoForm?.personalInfo)) {
      history.push(ROUTE_PATH.SHIELD_STARTER_SINGPASS_PERSMISSION);
    } else {
      history.push(
        `${ROUTE_PATH.SHIELD_STARTER_MY_INFO}?transaction_id=${transactionId}`
      );
    }
  };

  const onModalYesProcess = () => {
    dispatch(updateEligible(false));
    history.push(ROUTE_PATH.SHIELD_STARTER_CONTACT_US);
  };

  const onModalNoProcess = () => {
    setBackModalVisible(false);
  };

  const accordionArgs = {
    theme: themeDefault,
    className: container_default_css,
    title: "Other things to note before you proceed",
    titleClassName: title_default_css,
    titleFontSize: 16,
    headerPadding: "24px 24px 24px 0",
    isExpanded: true,
    showBottomLine: true,
    showHeaderLine: true,
    bottomLineColor: "#c4c4c4",
    bottomLineThickness: "1px",
    contentMarginLeft: "0px",
    contentMarginRight: "0px",
    bottomLineClassName: "margin:10px",
    headerBackgroundColor: "#F4F6F9",
    showHeaderBackground: true,
  };

  useEffect(() => {
    if (!basicDetails || !coverage) {
      history.push(ROUTE_PATH.SHIELD_STARTER_GET_QUOTE);
    } else {
      if (!isLoaded) {
        setIsLoaded(true);
      }
      trackOnLoad("sss_start_application_check_eligibility");
    }
  }, [basicDetails, coverage, history]);

  const data = {
    declarationPoints: [
      `I’m proficient in both spoken and written English`,
      `I have attained at least a GCE N-Level or O-Level certification, or equivalent academic qualification`,
      `I’m not receiving Additional Premium Support (APS) from the Government to pay for my MediShield Life and/or CareShield Life premiums`,
      `I’m purchasing the plan without any advice from a financial adviser representative and I take responsibility to ensure that this plan suits my needs`,
      `I’m a Singapore Citizen or Permanent Resident with a MediSave account`,
    ],
    rules: [
      `You may wish to separately seek advice on the suitability of
      the Singlife Shield Starter and Health Plus Starter policy.`,
      `In the event that you choose not to seek advice on the
      suitability of the Singlife Shield Starter and Health Plus Starter
      policy, you should consider if the Singlife Shield Starter and
      Health Plus Starter policy is suitable for your financial
      circumstances and needs.`,
    ],
  };

  return (
    <MainContainer backButtonPath={ROUTE_PATH.SHIELD_STARTER_VIEW_QUOTATION}>
      <FormContainer>
        <FormHeaderContainer>
          <FormHeaderTitleContainer marginHorizontal={"80px"}>
            <Text
              theme={themeDefault}
              align={"center"}
              className={HeaderTitleCss}
            >
              Before we start, please confirm that:
            </Text>
          </FormHeaderTitleContainer>
        </FormHeaderContainer>

        <DeclarationBulletsContainer>
          {data.declarationPoints.map((point, index) => (
            <Bullet className={bulletStyle} key={`bullet-${index}-dec`}>
              <Text theme={themeDefault} className={DeclarationParagraph}>
                {point}
              </Text>
            </Bullet>
          ))}
        </DeclarationBulletsContainer>

        <FormButtonContainer>
          <Button
            onClick={onNoProcess}
            width={"282px"}
            variant={"secondary"}
            theme={themeDefault}
            label={"I do not agree"}
          ></Button>
          <Button
            onClick={onYesProcess}
            width={"282px"}
            variant={"default"}
            theme={themeDefault}
            label={"Agree to all"}
          ></Button>
        </FormButtonContainer>
      </FormContainer>

      <Modal show={backModalVisible} onClose={onModalNoProcess}>
        <BackModal
          onYesClick={onModalYesProcess}
          onNoClick={onModalNoProcess}
        />
      </Modal>

      <FormContentContainer maxWidth={"792px"} margin={"0 auto"}>
        <AccordionContainer>
          <Accordion {...accordionArgs}>
            <div style={{ paddingBottom: "20px" }}>
              <Bullet>
                <Text theme={themeDefault} className={AccordionParagraph}>
                  You may reach us {" "}
                  <Link
                    fontWeight={600}
                    fontSize={14}
                    theme={themeDefault}
                    variant="button"
                    text={"here"}
                    onClick={() => {
                      history.push(ROUTE_PATH.SHIELD_STARTER_CONTACT_US);
                    }}
                  /> {" "}
                  for any queries about the product.
                </Text>
              </Bullet>
              {data.rules.map((rule, index) => (
                <Bullet key={`bullet-${index}-rule`}>
                  <Text theme={themeDefault} className={AccordionParagraph}>
                    {rule}
                  </Text>
                </Bullet>
              ))}
            </div>
          </Accordion>
        </AccordionContainer>
      </FormContentContainer>
    </MainContainer>
  );
}

export default Eligibility;
